import Vue from 'vue';
import Router from 'vue-router';
import i18n from '../i18n'

Vue.use(Router);
const router = new Router({
    routes: [{
        path: '/',
        redirect: '/RunningStatus'
    },
    // routes: [{
    //     path: '/',
    //     redirect: '/BigScreen'
    // },
    {
        path: '/',
        component: () =>
            import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
        meta: {
            title: '自述文件',
            titleKey: 'layout.header.logo'
        },
        children: [{
            path: '/BasicInfo',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/BasicInfo.vue'),
            meta: {
                title: 'KJ3231煤炭产量管理系统首页'
            }
        },
        {
            path: '/i18n',
            component: () =>
                import('../components/page/I18n.vue'),
            meta: {
                title: '国际化演示',
                titleKey: 'i18n.breadcrumb'
            }
        },
        {
            path: '/BeltScalePage',
            component: () =>
                import('../components/common/BeltScalePage.vue'),
            meta: {
                title: '皮带秤首页'
            }
        },
        {
            path: '/BigScreen',
            name: 'BigScreen',
            // 使用HTML页面
            beforeEnter() {
                window.location.href = '/bigscreen/BigScreen.html';
            }
        },
        {
            path: '/ScaleRackGroup',
            component: () =>
                import('../components/AIWeighingSystem/ScaleRackGroup.vue'),
            meta: {
                title: '秤架组管理'
            }
        },
        {
            path: '/ScaleRackRoller',
            component: () =>
                import('../components/AIWeighingSystem/ScaleRackRoller.vue'),
            meta: {
                title: '托辊管理'
            }
        },
        {
            path: '/RollersElectricMotor',
            component: () =>
                import('../components/AIWeighingSystem/RollersElectricMotor.vue'),
            meta: {
                title: '托辊电机管理'
            }
        },
        {
            path: '/RollersLoadCells',
            component: () =>
                import('../components/AIWeighingSystem/RollersLoadCells.vue'),
            meta: {
                title: '托辊称重传感器管理'
            }
        },
        {
            path: '/RollersShockSensor',
            component: () =>
                import('../components/AIWeighingSystem/RollersShockSensor.vue'),
            meta: {
                title: '托辊震动传感器管理'
            }
        },
        {
            path: '/AiWeighingSystemSetup',
            component: () =>
                import('../components/AIWeighingSystem/AiWeighingSystemSetup.vue'),
            meta: {
                title: 'AI称重系统设置'
            }
        },
        {
            path: '/AiMonitorEqu',
            component: () =>
                import('../components/AIWeighingSystem/AiMonitorEqu.vue'),
            meta: {
                title: 'AI称重系统监控设置'
            }
        },
        {
            path: '/BasicInfoHome',
            component: () =>
                import('../components/common/BasicInfoHome.vue'),
            meta: {
                title: '皮带秤首页'
            }
        },
        {
            path: '/DynamicInformation',
            component: () =>
                import('../components/common/DynamicInformation.vue'),
            meta: {
                title: '动态信息',
                titleKey: 'pages.dynamic.cumulativeT'
            }
        },
        {
            path: '/BeltScaleCondition',
            component: () =>
                import('../components/common/BeltScaleCondition.vue'),
            meta: {
                title: '皮带秤状态',
                titleKey: 'pages.basicInfo.beltSpeedMs'
            }
        },
        {
            path: '/RunningStatus',
            component: () =>
                import('../components/common/RunningStatus.vue'),
            meta: {
                title: '运行状态',
                titleKey: 'pages.running.cumulativeT'
            }
        },
        {
            path: '/HandoverList',
            component: () =>
                import('../components/Scale/HandoverList.vue'),
            meta: {
                title: '交接清单',
                titleKey: 'pages.handover.print'
            }
        },
        {
            path: '/MoreDeviceInfo',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/MoreDeviceInfo.vue'),
            meta: {
                title: '设备运行信息',
                titleKey: 'pages.moreDeviceInfo.dayBar'
            }
        },
        {
            path: '/DeviceList',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/DeviceList.vue'),
            meta: {
                title: '设备列表',
                titleKey: 'pages.deviceList.breadcrumb'
            }
        },
        {
            path: '/WashingProductAuditForm',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/WashingProductAuditForm.vue'),
            meta: {
                title: '洗选产品审核表'
            }
        },
        {
            path: '/WashingProductDailyReport',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/WashingProductDailyReport.vue'),
            meta: {
                title: '洗选产品日报表',
                titleKey: 'pages.washingReport.breadcrumb'
            }
        },
        {
            path: '/CoalWashDataSet',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/CoalWashDataSet.vue'),
            meta: {
                title: '洗选数据平台功能设置'
            }
        },
        {
            path: '/ScaleIndex',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/ScaleIndex.vue'),
            meta: {
                title: '给料机首页'
            }
        },
        {
            path: '/MonitorInfo',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/MonitorInfo.vue'),
            meta: {
                title: '监测信息'
            }
        },
        {
            path: '/About',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/About.vue'),
            meta: {
                title: '系统信息',
                titleKey: 'pages.about.breadcrumb'
            }
        },
        {
            path: '/GlobalSet',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/GlobalSet.vue'),
            meta: {
                title: '全局设置',
                titleKey: 'pages.globalSet.breadcrumb'
            }
        },
        {
            path: '/UserManage',
            component: () =>
                import('../components/SysManage/UserManage'),
            meta: {
                title: '用户管理',
                titleKey: 'pages.userManage.breadcrumb'
            }
        },
        {
            path: '/PersonInfo',
            component: () =>
                import('../components/SysManage/PersonInfo'),
            meta: {
                title: '个人信息',
                titleKey: 'pages.personInfo.tabsBase'
            }
        },
        {
            path: '/Balance',
            component: () =>
                import('../components/Scale/Balance'),
            meta: {
                title: '设备管理',
                titleKey: 'pages.balance.breadcrumb'
            }
        },
        {
            path: '/MotorMonitoringDevice',
            component: () =>
                import('../components/Scale/MotorMonitoringDevice'),
            meta: {
                title: '电机监测设备',
                titleKey: 'pages.motorMonitoringDevice.breadcrumb'
            }
        },
        {
            path: '/ProductPlan',
            component: () =>
                import('../components/Scale/ProductPlan'),
            meta: {
                title: '产量计划管理',
                titleKey: 'pages.productPlan.breadcrumb'
            }
        },
        {
            path: '/Dept',
            component: () =>
                import('../components/SysManage/Dept'),
            meta: {
                title: '部门管理',
                titleKey: 'pages.dept.breadcrumb'
            }
        },
        {
            path: '/CoalPreparationPlant',
            component: () =>
                import('../components/SysManage/CoalPreparationPlant'),
            meta: {
                title: '选煤厂管理'
            }
        },
        {
            path: '/Frequency',
            component: () =>
                import('../components/Scale/Frequency'),
            meta: {
                title: '计划管理',
                titleKey: 'pages.frequency.breadcrumb'
            }
        },
        {
            path: '/ScaleGroup',
            component: () =>
                import('../components/Scale/ScaleGroup.vue'),
            meta: {
                title: '给料机组管理',
                titleKey: 'pages.scaleGroup.breadcrumb'
            }
        },
        {
            path: '/BalanceEmpower',
            component: () =>
                import('../components/Scale/BalanceEmpower.vue'),
            meta: {
                title: '设备权限',
                titleKey: 'pages.balanceEmpower.breadcrumb'
            }
        },
        {            
            path: '/DischargeCurve',            redirect: '/CombinedCurve'        
        },        
        {            
            path: '/CombinedCurve',            
            component: () =>                
                import('../components/Scale/CombinedCurve.vue'),            
            meta: {                title: '流量速度曲线', titleKey: 'pages.combinedCurve.breadcrumb'            }        
        },
        {            
            path: '/SpeedCurve',            
            redirect: '/CombinedCurve'        },
        {
            path: '/RecordSearch',
            component: () =>
                import('../components/Scale/RecordSearch.vue'),
            meta: {
                title: '记录查询',
                titleKey: 'pages.recordSearch.breadcrumb'
            }
        },
        {
            path: '/CoalInforUploadRecord',
            component: () =>
                import('../components/Scale/CoalInforUploadRecord.vue'),
            meta: {
                title: '煤炭信息监管服务平台上传记录',
                titleKey: 'pages.coalUploadRecord.breadcrumb'
            }
        },
        {
            path: '/CoalWashDataUploadRecord',
            component: () =>
                import('../components/Scale/CoalWashDataUploadRecord.vue'),
            meta: {
                title: '洗选数据联网数据上传记录'
            }
        },
        {
            path: '/ClearData',
            component: () =>
                import('../components/Scale/ClearData.vue'),
            meta: {
                title: '数据清空',
                titleKey: 'pages.clearData.breadcrumb'
            }
        },
        {
            path: '/HisData',
            component: () =>
                import('../components/Scale/HisData.vue'),
            meta: {
                title: '历史数据',
                titleKey: 'pages.hisData.breadcrumb'
            }
        },
        {
            path: '/StartStopRecord',
            component: () =>
                import('../components/Scale/StartStopRecord.vue'),
            meta: {
                title: '启停记录',
                titleKey: 'pages.startStopRecord.breadcrumb'
            }
        },
        {
            path: '/MotorInfo',
            component: () =>
                import('../components/Scale/MotorInfo.vue'),
            meta: {
                title: '电机信息'
            }
        },
        {
            path: '/OfflineRecord',
            component: () =>
                import('../components/Scale/OfflineRecord.vue'),
            meta: {
                title: '离线记录',
                titleKey: 'pages.offlineRecord.breadcrumb'
            }
        },
        {
            path: '/YearCCData',
            component: () =>
                import('../components/Scale/YearCCData.vue'),
            meta: {
                title: '年超产查询',
                titleKey: 'pages.yearCCData.breadcrumb'
            }
        },
        {
            path: '/MonthCCData',
            component: () =>
                import('../components/Scale/MonthCCData.vue'),
            meta: {
                title: '月超产查询',
                titleKey: 'pages.monthCCData.breadcrumb'
            }
        },
        {
            path: '/MTRealtimeList',
            component: () =>
                import('../components/Scale/MTRealtimeList.vue'),
            meta: {
                title: '实时列表显示',
                titleKey: 'pages.mtRealtimeList.breadcrumb'
            }
        },
        {
            path: '/MTSevereOverYearShow',
            component: () =>
                import('../components/Scale/MTSevereOverYearShow.vue'),
            meta: {
                title: '严重超产按年显示',
                titleKey: 'pages.mtSevereOverYearShow.breadcrumb'
            }
        },
        {
            path: '/MTSevereOverMonthShow',
            component: () =>
                import('../components/Scale/MTSevereOverMonthShow.vue'),
            meta: {
                title: '严重超产按月显示',
                titleKey: 'pages.mtSevereOverMonthShow.breadcrumb'
            }
        },
        {
            path: '/MTOverYearShow',
            component: () =>
                import('../components/Scale/MTOverYearShow.vue'),
            meta: {
                title: '超产按年显示',
                titleKey: 'pages.mtOverYearShow.breadcrumb'
            }
        },
        {
            path: '/MTOverMonthShow',
            component: () =>
                import('../components/Scale/MTOverMonthShow.vue'),
            meta: {
                title: '超产按月显示',
                titleKey: 'pages.mtOverMonthShow.breadcrumb'
            }
        },
        {
            path: '/MTOutputYearQuery',
            component: () =>
                import('../components/Scale/MTOutputYearQuery.vue'),
            meta: {
                title: '产量按年查询显示',
                titleKey: 'pages.mtOutputYearQuery.breadcrumb'
            }
        },
        {
            path: '/MTOutputMonthQuery',
            component: () =>
                import('../components/Scale/MTOutputMonthQuery.vue'),
            meta: {
                title: '产量按月查询显示',
                titleKey: 'pages.mtOutputMonthQuery.breadcrumb'
            }
        },
        {
            path: '/MTOutputDayQuery',
            component: () =>
                import('../components/Scale/MTOutputDayQuery.vue'),
            meta: {
                title: '产量按日查询显示',
                titleKey: 'pages.mtOutputDayQuery.breadcrumb'
            }
        },
        {
            path: '/MTAbnormalDisplay',
            component: () =>
                import('../components/Scale/MTAbnormalDisplay.vue'),
            meta: {
                title: '系统工作异常显示',
                titleKey: 'pages.mtAbnormalDisplay.breadcrumb'
            }
        },
        {
            path: '/FrequencyData',
            component: () =>
                import('../components/Scale/FrequencyData.vue'),
            meta: {
                title: '班产量查询',
                titleKey: 'pages.frequencyData.breadcrumb'
            }
        },
        {
            path: '/HourData',
            component: () =>
                import('../components/Scale/HourData.vue'),
            meta: {
                title: '时产量查询',
                titleKey: 'pages.hourData.breadcrumb'
            }
        },
        {
            path: '/DayData',
            component: () =>
                import('../components/Scale/DayData.vue'),
            meta: {
                title: '日产量查询',
                titleKey: 'pages.dayData.breadcrumb'
            }
        },
        {
            path: '/MonthData',
            component: () =>
                import('../components/Scale/MonthData.vue'),
            meta: {
                title: '月产量查询',
                titleKey: 'pages.monthData.breadcrumb'
            }
        },
        {
            path: '/YearData',
            component: () =>
                import('../components/Scale/YearData.vue'),
            meta: {
                title: '年产量查询',
                titleKey: 'pages.yearData.breadcrumb'
            }
        },
        {
            path: '/HourlyPower',
            component: () =>
                import('../components/Scale/HourlyPower.vue'),
            meta: {
                title: '时用电量查询',
                titleKey: 'pages.hourlyPower.breadcrumb'
            }
        },
        {
            path: '/DailyPower',
            component: () =>
                import('../components/Scale/DailyPower.vue'),
            meta: {
                title: '日用电量查询',
                titleKey: 'pages.dailyPower.breadcrumb'
            }
        },
        {
            path: '/MonthlyPower',
            component: () =>
                import('../components/Scale/MonthlyPower.vue'),
            meta: {
                title: '月用电量查询',
                titleKey: 'pages.monthlyPower.breadcrumb'
            }
        },
        {
            path: '/AnnualPower',
            component: () =>
                import('../components/Scale/AnnualPower.vue'),
            meta: {
                title: '年用电量查询',
                titleKey: 'pages.annualPower.breadcrumb'
            }
        },
        {
            path: '/DailySales',
            component: () =>
                import('../components/Scale/DailySales.vue'),
            meta: {
                title: '日累计销量',
                titleKey: 'pages.dailySales.breadcrumb'
            }
        },
        {
            path: '/MonthlySales',
            component: () =>
                import('../components/Scale/MonthlySales.vue'),
            meta: {
                title: '月累计销量',
                titleKey: 'pages.monthlySales.breadcrumb'
            }
        },
        {
            path: '/AnnualSales',
            component: () =>
                import('../components/Scale/AnnualSales.vue'),
            meta: {
                title: '年累计销量',
                titleKey: 'pages.annualSales.breadcrumb'
            }
        },
        {
            path: '/SalesDetails',
            component: () =>
                import('../components/Scale/SalesDetails.vue'),
            meta: {
                title: '磅单详情',
                titleKey: 'pages.salesDetails.breadcrumb'
            }
        },
        {
            path: '/CoalTaxCalc',
            component: () =>
                import('../components/common/CoalTaxCalc.vue'),
            meta: {
                title: '折算与税费测算',
                titleKey: 'pages.coalTaxCalc.breadcrumb'
            }
        },
        {
            path: '/AlarmControl',
            component: () =>
                import('../components/common/AlarmControl.vue'),
            meta: {
                title: '报警控制',
                titleKey: 'pages.alarmControl.breadcrumb'
            }
        },
        {
            path: '/DataMain',
            component: () =>
                import('../components/SysManage/DataMain.vue'),
            meta: {
                title: '数据字典',
                titleKey: 'pages.dataMain.breadcrumb'
            }
        },
        {
            path: '/Menu',
            component: () =>
                import('../components/SysManage/Menu.vue'),
            meta: {
                title: '菜单管理',
                titleKey: 'pages.menu.breadcrumb'
            }
        },
        {
            path: '/Role',
            component: () =>
                import('../components/SysManage/Role.vue'),
            meta: {
                title: '角色管理',
                titleKey: 'pages.role.breadcrumb'
            }
        },
        {
            path: '/EquimentVersion',
            component: () =>
                import('../components/SysManage/EquimentVersion.vue'),
            meta: {
                title: '协议版本信息',
                titleKey: 'pages.equimentVersion.breadcrumb'
            }
        },
        {
            path: '/componentsA',
            component: () =>
                import('../components/TestUnit/componentsA.vue'),
            meta: {
                title: '组件A'
            }
        },
        {
            path: '/componentsC',
            component: () =>
                import('../components/TestUnit/componentsC.vue'),
            meta: {
                title: '组件C'
            }
        },
        {
            path: '/componentsD',
            component: () =>
                import('../components/TestUnit/componentsD.vue'),
            meta: {
                title: '组件D'
            }
        },
        {
            path: '/BaseForm',
            component: () =>
                import('../components/page/BaseForm.vue'),
            meta: {
                title: '基础表单'
            }
        },
        {
            path: '/EventRecord',
            component: () =>
                import('../components/Scale/EventRecord.vue'),
            meta: {
                title: '监控记录',
                titleKey: 'pages.eventRecord.breadcrumb'
            }
        },
        // {
        //     path: '/CoalEquipMonitor',
        //     component: () =>
        //         import('../components/Scale/CoalEquipMonitor.vue'),
        //     meta: {
        //         title: '输煤设备状态监测'
        //     }
        // },
        {
            path: '/Tabs',
            component: () =>
                import('../components/page/Tabs.vue'),
            meta: {
                title: '消息中心',
                titleKey: 'pages.tabs.breadcrumb'
            }
        },
        {
            path: '/MonitorEqu',
            component: () =>
                import('../components/SysManage/MonitorEqu.vue'),
            meta: {
                title: '监控设备',
                titleKey: 'pages.monitorEqu.breadcrumb'
            }
        },
        {
            path: '/RolePermission',
            component: () =>
                import('../components/SysManage/role-permission.vue'),
            meta: {
                title: '角色权限',
                titleKey: 'pages.rolePermission.breadcrumb'
            }
        },
        {
            path: '/componentsB',
            component: () =>
                import('../components/TestUnit/componentsB.vue'),
            meta: {
                title: '组件B'
            }
        },
        {
            path: '/404',
            component: () =>
                import( /* webpackChunkName: "404" */ '../components/page/404.vue'),
            meta: {
                title: '404'
            }
        },
        {
            path: '/donate',
            component: () =>
                import( /* webpackChunkName: "donate" */ '../components/page/Donate.vue'),
            meta: {
                title: '支持作者'
            }
        },
        ]
    },
    {
        path: '/login',
        component: () =>
            import( /* webpackChunkName: "login" */ '../components/page/Login.vue')
    },
    {
        path: '*',
        redirect: '/404'
    },
    {
        path: '/3d',
        name: '3d',
        component: () => import('../views/3d/Meta3d.vue'),
    },
    ]
});
router.beforeEach((to, from, next) => {
    const key = to.meta && to.meta.titleKey
    if (key) {
        document.title = i18n.t(key)
    } else if (to.meta && to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
export default router
